define('viewmodels/ProjectLanding',['plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'services/routeconfig', 'services/AppRoutes', 'viewmodels/header', 'viewmodels/GeneralSettings', 'durandal/system'],
    function (router, appsecurity, navigation, app, logger, routeconfig, AppRoutes, header, ObjGeneralSettings, system) {
        var title = 'ProjectLanding';
        var vm = {
            activate: function () {

                //if (vm.ObjGeneralSettings === undefined || vm.ObjGeneralSettings.LocalizedTextList() === undefined || ((vm.ObjGeneralSettings.LocalizedTextList() !== undefined || vm.ObjGeneralSettings.LocalizedTextList() !== null) && vm.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                //    vm.ObjGeneralSettings.GetLocalizedData().then(function () {

                //        if (vm.ObjGeneralSettings.LocalizedTextList() == undefined || vm.ObjGeneralSettings.LocalizedTextList() == null || vm.ObjGeneralSettings.LocalizedTextList().length <= 0 || vm.ObjGeneralSettings.LocalizedIndexList() == undefined || vm.ObjGeneralSettings.LocalizedIndexList() == null)
                //            vm.LocaleCheckFlag(false);
                //        else
                //            vm.LocaleCheckFlag(true);
                //    });
                //}
                //else {
                //    if (vm.ObjGeneralSettings.LocalizedTextList() == undefined || vm.ObjGeneralSettings.LocalizedTextList() == null || vm.ObjGeneralSettings.LocalizedTextList().length <= 0 || vm.ObjGeneralSettings.LocalizedIndexList() == undefined || vm.ObjGeneralSettings.LocalizedIndexList() == null)
                //        vm.LocaleCheckFlag(false);
                //    else
                //        vm.LocaleCheckFlag(true);
                //}
            },
            appsecurity: appsecurity,
            AppRoutes: AppRoutes,
            app: app,
            ObjGeneralSettings: ObjGeneralSettings,
            header: header,
            attached: attached,
            detached: detached,
            ClientDetails: ko.observableArray([]),
            imagePath: ko.observable(),
            ProjectClick: ProjectClick,
            LocaleCheckFlag: ko.observable(false), 
            Logout: function () {
                var self = this;
                appsecurity.logout()
                    .done(function (token) {
                        $("input[name='__RequestVerificationToken']").val(token);
                        appsecurity.clearAuthInfo();
                        window.location = routeconfig.login;
                    })
                    .fail(function (error) {
                        appsecurity.clearAuthInfo();
                        window.location = routeconfig.login;
                    });
            }
        };
        return vm;

        function attached() {
            try {
                $("body").removeClass("login-page");
                $('body').addClass("hold-transition");
                $('.main-header').hide();
                $('.main-sidebar').hide();
                $("#master-header-content").removeClass("content-wrapper");

                DefaultButton =
                    $("header").css({ "display": "none" });
                $('.static-header').show();
                $('#loginPageLogo').hide();

                vm.appsecurity.ChangeperiodofAssessmentFlag(false);
                var CompletePath = '../../../BankImages/';
                vm.imagePath("C:/ferarai.png");
                vm.appsecurity.initializeAuth().done(function () {
                    $("#ShowHideSettingsPopUp").hide();
                    $("#ShowHideFAQPopUp").hide();
                });
                GetProjectsList();
                vm.appsecurity.GetCurrentLocaleOfUser();
                //if (vm.ObjGeneralSettings === undefined || vm.ObjGeneralSettings.LocalizedTextList() === undefined || ((vm.ObjGeneralSettings.LocalizedTextList() !== undefined || vm.ObjGeneralSettings.LocalizedTextList() !== null) && vm.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                    ////vm.ObjGeneralSettings.GetLocalizedData().then(function () {
                    ////    vm.ObjGeneralSettings.LocalizedTextList(ObjGeneralSettings.LocalizedTextList());
                    ////    vm.ObjGeneralSettings.LocalizedIndexList(ObjGeneralSettings.LocalizedIndexList());
                    ////    if (vm.ObjGeneralSettings.LocalizedTextList() == undefined || vm.ObjGeneralSettings.LocalizedTextList() == null || vm.ObjGeneralSettings.LocalizedTextList().length <= 0 || vm.ObjGeneralSettings.LocalizedIndexList() == undefined || vm.ObjGeneralSettings.LocalizedIndexList() == null)
                    ////        vm.LocaleCheckFlag(false);
                    ////    else
                    ////        vm.LocaleCheckFlag(true);
                    ////});
                //}
                //else {
                //    if (vm.ObjGeneralSettings.LocalizedTextList() == undefined || vm.ObjGeneralSettings.LocalizedTextList() == null || vm.ObjGeneralSettings.LocalizedTextList().length <= 0 || vm.ObjGeneralSettings.LocalizedIndexList() == undefined || vm.ObjGeneralSettings.LocalizedIndexList() == null)
                //        vm.LocaleCheckFlag(false);
                //    else
                //        vm.LocaleCheckFlag(true);
                //}
                
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in Landing.js';
                logger.logMessage(msg);
            }
        }

        function detached() {
            try {
                $('#Masterdiv').addClass("pagelevelscroll");
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: detached() method in Landing.js';
                logger.logMessage(msg);
            }
        }
        function GetProjectsList() {
            try {
                vm.ObjGeneralSettings.GetLocalizedData().then(function () {
                    vm.ObjGeneralSettings.LocalizedTextList(ObjGeneralSettings.LocalizedTextList());
                    vm.ObjGeneralSettings.LocalizedIndexList(ObjGeneralSettings.LocalizedIndexList());
                    if (vm.ObjGeneralSettings.LocalizedTextList() == undefined || vm.ObjGeneralSettings.LocalizedTextList() == null || vm.ObjGeneralSettings.LocalizedTextList().length <= 0 || vm.ObjGeneralSettings.LocalizedIndexList() == undefined || vm.ObjGeneralSettings.LocalizedIndexList() == null)
                        vm.LocaleCheckFlag(false);
                    else
                        vm.LocaleCheckFlag(true);
                });

                $.ajax({
                    url: "/api/Account/GetProjectsList",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult != null) {
                            if (jsonResult.length != 0 && jsonResult[0].ErrorId == -99) {
                                logger.logError(jsonResult[0].ErrorCode + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(vm), true);
                            }
                            else {
                                var MappedClientDetailsModelList = $.map(jsonResult, function (result) {
                                    var Object = new clientDetailsModel(result);
                                    return Object;
                                });
                                vm.ClientDetails(MappedClientDetailsModelList);
                                header.ClientsCount(vm.ClientDetails().length);
                                BindDynamicHtmlTiles();
                                $("#ShowHideSettingsPopUp").hide();
                                $("#ShowHideFAQPopUp").hide();
                            }
                        }
                        else {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(vm), true);
                        }

                    })
                    .fail(function (error, status) {

                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in UnlockUser() method in UserRole.js';

            }
        }

        function BindDynamicHtmlTiles() {
            try {
                var DynamicHTML = "";
                for (var i = 0; i < vm.ClientDetails().length; i++) {

                    DynamicHTML += '<div class="col-md-3 mt-1 mb-1">'
                    DynamicHTML += '<div class="ccard">';
                    DynamicHTML += '<blockquote class="nd-flex card-bodyquote">';
                    DynamicHTML += '<div class="project-name"><h4>' + vm.ClientDetails()[i].ClientCodeName() + '</h4><i class="fa fa-institution"></i></div>';
                    DynamicHTML += '</blockquote >'
                    if (vm.ClientDetails()[i].ClientName().length == 0 | vm.ClientDetails()[i].ClientName() == " " | vm.ClientDetails()[i].ClientName() == "") {
                        DynamicHTML += '<label>(' + (!vm.LocaleCheckFlag() || vm.ObjGeneralSettings.LocalizedIndexList.indexOf('NoDataAvailable') == -1) ? 'No data available' : vm.ObjGeneralSettings.LocalizedTextList()[vm.ObjGeneralSettings.LocalizedIndexList.indexOf('NoDataAvailable')].Name() + ')</label></br><label>-</label></br><label>-</label></br>'
                    }
                    else {
                        DynamicHTML += '<label>' + vm.ClientDetails()[i].ClientName() + '</label></br>';
                        DynamicHTML += '<label>' + vm.ClientDetails()[i].HdqName() + '</label></br>';
                        DynamicHTML += '<label>' + vm.ClientDetails()[i].AddressCity() + '</label>';
                    }
                    DynamicHTML += '</div>'
                    var textNavigate = (!vm.LocaleCheckFlag() || vm.ObjGeneralSettings.LocalizedIndexList.indexOf('Navigateto') == -1) ? 'Navigate to' : vm.ObjGeneralSettings.LocalizedTextList()[vm.ObjGeneralSettings.LocalizedIndexList.indexOf('Navigateto')].Name();
                    DynamicHTML += '<button name=' + vm.ClientDetails()[i].ClientId() + '-' + vm.ClientDetails()[i].ClientCodeName() + ' class="pull-right primary-btn btnprojectmgmnt" data-bind="click:$root.ProjectClick">' + textNavigate + ' ' + vm.ClientDetails()[i].ClientCodeName() + ' <i class="demo-icon icon-arrow_double_right_special"></i> </button>'
                    DynamicHTML += '</div>';
                }

                document.getElementById('HtmlDiv').innerHTML = DynamicHTML
                var element = $('#HtmlDiv')[0];
                ko.cleanNode(element);
                ko.applyBindings(vm, document.getElementById('HtmlDiv'));
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in ProjectClick() method in ProjectLanding.js';
                logger.logMessage(msg);
            }
        }

        function ProjectClick(data, event) {
            try {

                var name = event.currentTarget.name;
                var list = name.split('-')
                var text = (!vm.LocaleCheckFlag() || vm.ObjGeneralSettings.LocalizedIndexList.indexOf('Doyouwantto') == -1) ? 'Do you want to ' : vm.ObjGeneralSettings.LocalizedTextList()[vm.ObjGeneralSettings.LocalizedIndexList.indexOf('Doyouwantto')].Name();
                app.showMessage(text + ' ' + event.currentTarget.innerText + '?', event.currentTarget.innerText, [(!vm.LocaleCheckFlag() || vm.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? 'Cancel' : vm.ObjGeneralSettings.LocalizedTextList()[vm.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name, (!vm.LocaleCheckFlag() || vm.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : vm.ObjGeneralSettings.LocalizedTextList()[vm.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name])
                    .then(function (option) {
                        var confirmText = ((!vm.LocaleCheckFlag() || vm.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : vm.ObjGeneralSettings.LocalizedTextList()[vm.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name()).toString();
                        if (option === confirmText) {
                            $('#loadingimgprjctlanding').show();
                            $('#HtmlDiv').hide();
                            NavigatetoClientSpeceficPage(list[0]);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in ProjectClick() method in ProjectLanding.js';
                logger.logMessage(msg);
            }
        }
        function clientDetailsModel(item) {
            try {
                var self = this;
                self.ClientId = ko.observable(item.ClientId);
                self.ClientCodeName = ko.observable($('<div/>').html(item.ClientCodeName).text())
                self.ClientName = ko.observable($('<div/>').html(item.ClientName).text());
                self.ShortName = ko.observable($('<div/>').html(item.ShortName).text());
                self.HdqName = ko.observable($('<div/>').html(item.HdqName).text());
                self.AddressLine1 = ko.observable($('<div/>').html(item.AddressLine1).text());
                self.AddressLine2 = ko.observable($('<div/>').html(item.AddressLine2).text());
                self.AddressCity = ko.observable($('<div/>').html(item.AddressCity).text());
                self.AddressState = ko.observable($('<div/>').html(item.AddressState).text());
                self.AddressCountry = ko.observable($('<div/>').html(item.AddressCountry).text());
                self.AddressPostalCode = ko.observable(item.AddressPostalCode);
                self.HeadName = ko.observable($('<div/>').html(item.HeadName).text());
                self.YearOfAssessment = ko.observable(item.YearOfAssessment);
                self.ImageCompletePath = ko.observable($('<div/>').html(item.ImageCompletePath).text());
                self.Flag = ko.observable(item.Flag);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: clientDetailsModel() method in ProjectLanding.js';
                logger.logMessage(msg);
            }
        };


        function NavigatetoClientSpeceficPage(data) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Account/PostProjectsList",
                    headers: headers,
                    data: { ClientId: data },
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call from NavigatetoClientSpeceficPage() method in ProjectLanding.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                        logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(vm), true);
                    }
                    else if (!isNaN(jsonResult) && parseInt(jsonResult) > 0) {
                        vm.appsecurity.ChangeperiodofAssessmentFlag(true);
                        router.navigate('Landing');
                    }
                    else if (!isNaN(jsonResult) && parseInt(jsonResult) == 0) {
                        logger.logError('An error occurred. Please contact your Administrator.', 'Error', system.getModuleId(vm), true);
                    }
                    else {
                        logger.logError('An error occurred. Please contact your Administrator.', 'Error', system.getModuleId(vm), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from NavigatetoClientSpeceficPage() method in ProjectLanding.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    $('#loadingimgprjctlanding').hide();
                    $('#HtmlDiv').show();
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in NavigatetoClientSpeceficPage() method in ProjectLanding.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail from NavigatetoClientSpeceficPage() method in ProjectLanding.js';
                    logger.logMessage(msg);
                }
            }
        }
    });



